<a class="insured-code-entry-container"
   [class.active-entry]="selected()"
   [routerLink]="['/insured', item().uuid]"
   [title]="item().name"
   (click)="onEntryClick()"
   (contextmenu)="onContextMenu($event)"
>
  <div class="insured-code-link">
    <span class="truncate">{{ item().companyCode }}</span>
  </div>
</a>
